import { Chip } from '@mui/material';

type ChipCellProps = {
  textColor?: string;
  backgroundColor?: string;
  label: string;
};

export const ChipCell = ({ textColor, backgroundColor, label }: ChipCellProps) => {
  return (
    !!label && (
      <Chip
        size="small"
        label={label}
        sx={{
          height: 'auto',
          color: textColor,
          backgroundColor,
        }}
      />
    )
  );
};
